import Fuse from 'fuse.js';
import type { CommandInternal } from '../../../../common/types/commands/index.tsx';
import { FUSE_SEARCH_OPTIONS } from './constants.tsx';

// This function is used to correct the weights of keywords in the search query when mutliple keywords are present
// This is needed as the compound query treats each keyword as a separate query and the weights are not adjusted
// So this should correct it so that having two keywords in the query is not twice as important as having one, and rather they each have half the weight
// ...and so on for more keywords
export const getFuseSearchOptions = (queryKeywordCount = 1): typeof FUSE_SEARCH_OPTIONS => ({
	...FUSE_SEARCH_OPTIONS,
	keys: FUSE_SEARCH_OPTIONS.keys?.map((key) =>
		typeof key === 'object' && 'name' in key
			? {
					...key,
					weight:
						key.name === 'searchKeywordsArray'
							? (key.weight ?? 1) / Math.max(queryKeywordCount, 1)
							: key.weight,
				}
			: key,
	),
});

export const createFuseFromCommands = (allCommands: CommandInternal[], queryKeywordCount = 1) =>
	new Fuse<CommandInternal>(allCommands, getFuseSearchOptions(queryKeywordCount));

// Split the keywords into a series of logical ORs as otherwise Fuse will only match one keyword at a time
export const searchFuseIndex = (fuse: Fuse<CommandInternal>, query: string) =>
	fuse.search({
		$or: [
			{
				name: query,
			},
			{
				shortcut: query,
			},
			{
				sectionName: query,
			},
			{
				$or: query.split(' ').map((word) => ({
					searchKeywordsArray: word,
				})),
			},
		],
	});
